import React, { useState } from "react";
import { Paper, Tabs, Tab } from '@material-ui/core';
import {AvionicsCommunication, InteriorInformation,AircraftFuel,AircraftBuildInfoOperationalData,  AssetInfo } from '../components'
import { TechSpecsNav } from '../../elements'
import useAssetInfo from '../hooks/useAssetInfo';
import { titanAviInstance } from "../../../shared/components";
import TAAircraftAttributes from "../components/TAAircraftAttributes";
import TAOpsReq from "../components/TAOpsReq";
import TARegulatoryComp from "../components/TARegulatoryComp";
import TALGInfo from "../components/TALGInfo";
import TAFuelInfo from "../components/TAFuelInfo";
import TAMiscellaneous from "../components/TAMiscellaneous";
const ConfigurationDetails = ({params}) => {
    const [tabIndex, setTabIndex] = useState('avionics-communication');
    const [titanTabIndex, setTitanTabIndex] = useState('aircraft-attributes');
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    return(
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{height:`${window.innerHeight-162}px`}}>
                <TechSpecsNav />
                {titanAviInstance ?
                 <div className="tech-specs-content">
                        <Paper elevation={0} className="console-paper" style={{ margin: '0 10px', marginBottom: '3px', overflow: 'auto' }}>
                            <Tabs style={{ overflow: 'auto', width: "max-content" }} scrollButtons='auto'  indicatorColor="primary" value={titanTabIndex} onChange={(event, newValue) => setTitanTabIndex(newValue)} >
                                {[
                                    { label: "Aircraft Attributes", value: 'aircraft-attributes' },
                                    { label: "Navigation/Communication", value: 'communication' },
                                    { label: "Interior Information", value: 'interior' },
                                    { label: "Operational Requirements", value: 'operational-requirements' },
                                    { label: "Regulatory Compliance", value: 'regulatory-compliance' },
                                    { label: "LG Information", value: 'lg-information' },
                                    { label: "Fuel information", value: 'fuel-information' },
                                    { label: "Miscellaneous", value: 'miscellaneous' }
                                ].map(titanTab => (
                                    <Tab key={titanTab.value} {...titanTab} style={{ paddingRight: 30, paddingLeft: 30 }} />
                                ))}
                            </Tabs>
                        </Paper>
                    <div>
                        {titanTabIndex === 'aircraft-attributes' ? <TAAircraftAttributes assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'communication' ? <AvionicsCommunication assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'interior' ? <InteriorInformation assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'operational-requirements' ? <TAOpsReq assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'regulatory-compliance' ? <TARegulatoryComp assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'lg-information' ? <TALGInfo assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'fuel-information' ? <TAFuelInfo assetInfoData={assetInfoData} />:null}
                        {titanTabIndex === 'miscellaneous' ? <TAMiscellaneous assetInfoData={assetInfoData} />:null}
                    </div>
                </div>
                :<div className="tech-specs-content">
                    <Paper elevation={0} className="console-paper" style={{margin:'0 10px', marginBottom:'3px'}}>
                        <Tabs indicatorColor="primary" value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)}>
                            <Tab label="Avionics/Communication" value={'avionics-communication'} />
                            <Tab label="Interior Information" value={'interior'} />
                            <Tab label="Fuel" value={'fuel'} />
                            <Tab label="Aircraft Build Info & Operational Data" className="tab-label" value={'aircraft-build-operational-data'} />
                        </Tabs>
                    </Paper>
                    <div>
                        {tabIndex === 'avionics-communication' ? <AvionicsCommunication  assetInfoData={assetInfoData}/>:null}
                        {tabIndex === 'interior' ? <InteriorInformation assetInfoData={assetInfoData} />:null}
                        {tabIndex === 'fuel' ? <AircraftFuel assetInfoData={assetInfoData} />:null}
                        {tabIndex === 'aircraft-build-operational-data' ? <AircraftBuildInfoOperationalData assetInfoData={assetInfoData}/>:null}
                    </div>
                </div>}
            </Paper>
        </section>
    )
}
export default ConfigurationDetails;